import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VupConsoleAccount } from '../models/vup-console-account.model';

@Injectable({
  providedIn: 'root'
})
export class VupConsoleService {
  constructor(
    @Inject('API_GATEWAY_URL') public gatewayUrl: any,
    private _http: HttpClient
  ) { }

  findAccount(email: string): Observable<VupConsoleAccount> {
    const [username, domain] = email.split('@');
    return this._http.get<VupConsoleAccount>(`${this.gatewayUrl}/console/accounts/domain/${domain}`);
  }

  listAccounts(): Observable<VupConsoleAccount[]> {
    return this._http.get<VupConsoleAccount[]>(`${this.gatewayUrl}/console/accounts/list-by-erp-system?erpSystem=protheus`);
  }

  listAccountsByIds(ids: number[]): Observable<VupConsoleAccount[]> {
    return this._http.get<VupConsoleAccount[]>(`${this.gatewayUrl}/console/accounts/list-by-ids?accountsIds=${ids.join('&accountsIds=')}`);
  }
}
